import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGE,
  messagingSenderId: process.env.REACT_APP_MSGID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Cloud Messaging is optional — kiosk / Electron contexts may not
// support the Notification or ServiceWorker APIs, and calling getMessaging there
// throws at import and takes the whole app down. Resolve it lazily + guarded.
let messaging = null;
const messagingReady = (async () => {
  try {
    if (typeof window !== "undefined" && (await isSupported())) {
      messaging = getMessaging(app);
    }
  } catch (err) {
    console.warn("Firebase Messaging unavailable in this environment:", err?.message || err);
  }
  return messaging;
})();

export const requestPermission = async () => {
  try {
    const m = await messagingReady;
    if (!m || typeof Notification === "undefined") return;
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("User Permission Denied.");
      return;
    }
    const currentToken = await getToken(m, { vapidKey: process.env.REACT_APP_VAPID_KEY });
    if (currentToken) {
      window.localStorage.setItem("token", currentToken);
    } else {
      console.log("Failed to generate the app registration token.");
    }
  } catch (err) {
    console.warn("requestPermission failed:", err?.message || err);
  }
};

requestPermission();

export const onMessageListener = () =>
  new Promise((resolve) => {
    messagingReady.then((m) => {
      if (m) onMessage(m, (payload) => resolve(payload));
    });
  });

// Initialize Firebase Services
export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage(app);
export const database = getDatabase(app);
export const functions = getFunctions(app);
